import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { LambdaService } from 'src/app/lambda.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
declare let $ : any;

@Component({
  selector: 'app-create-client-subscription',
  templateUrl: './create-client-subscription.component.html',
  styleUrls: ['./create-client-subscription.component.scss']
})
export class CreateClientSubscriptionComponent implements OnInit {

  subscription = {
    name: ''
  }

  saveSubscription: boolean = false;

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    public themingService: ThemingService,
    private settingsService: SettingsService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.saveSubscription = false;
  }

  changeSubscriptionName(event: Event) {
    const element = event.target as HTMLInputElement;
    this.subscription.name = element.value;
  }

  validateFormData() {
    if (!this.subscription.name || this.subscription.name.trim() === '') {
      $('#requiredSubscriptionModal').modal('show');
      return;
    }
    this.createClientSubscription();
  }

  setListingSubscriptions(){
    this.settingsService.setListingSubscriptions();
  }

  createClientSubscription() {
    $('#subscriptionLoadingModal').modal({ backdrop: 'static', keyboard: false });
    $('#subscriptionLoadingModal').modal('show');
    this.saveSubscription = false;
    this.lambdaService.createClientSubscription(
      this.themingService.shopId,
      this.subscription.name,

    ).then((data: any) => {
      if (data.status === 200) {
        $('#subscriptionLoadingModal').modal('hide');
        $('#successSubscriptionModal').modal('show');
        this.saveSubscription = true;
        this.resetForm();
        setTimeout(() => {
          this.closeModal();
        }, 2000);
      } else {
        $('#errorSubscriptionModal').modal('show');
        $('#subscriptionLoadingModal').modal('hide');
      }
    }).catch((error) => {
      console.error(error);
      $('#errorSubscriptionModal').modal('show');
      $('#subscriptionLoadingModal').modal('hide');
    });
  }

  resetForm() {
    this.subscription.name = '';
  }

  closeModal() {
    $('#successSubscriptionModal').modal('hide');
    $('#errorSubscriptionModal').modal('hide');
    $('#requiredSubscriptionModal').modal('hide');
    this.resetForm();
    this.saveSubscription = false;
  }

}
